import AxiosClient from '../../services/axios.services';
import GestorDocumentalClient from '../../services/gestorDocumental.services';
import config from '../../config';
class GestorDocumentalServices {
  getDocuments = params => AxiosClient.get('/api/app/archivos_gestor/', {
    headers: {'Content-Type': 'application/json'},
    params: params
  });
  saveDocument = data => AxiosClient.post('/api/app/archivos_gestor_postViewSet/', data, {
    headers: {'Content-Type': 'application/json'}
  });
  editDocument = (id, data) => AxiosClient.put(`/api/app/archivos_gestor_postViewSet/${id}/`, data, {
    headers: {'Content-Type': 'application/json'}
  });
  saveSancionesDocument = data => AxiosClient.post('/api/app/archivos_gestor_formatos_oficiales_post/', data, {
    headers: {'Content-Type': 'application/json'}
  });
  editSancionesDocument = (id, data) => AxiosClient.put(`/api/app/archivos_gestor_formatos_oficiales_post/${id}/`, data, {
    headers: {'Content-Type': 'application/json'}
  });
  saveCompetenciesDocument = data => AxiosClient.post('/api/app/archivos_gestor_competencia_postViewSet/', data, {
    headers: {'Content-Type': 'application/json'}
  });
  editCompetenciesDocument = (id, data) => AxiosClient.put(`/api/app/archivos_gestor_competencia_postViewSet/${id}/`, data, {
    headers: {'Content-Type': 'application/json'}
  });
  // getDocuments = params => AxiosClient.get('/api/app/nucleo_gestor_documental/', {
  //   headers: {'Content-Type': 'application/json'},
  //   params: params
  // });
  // saveDocument = data => AxiosClient.post('/api/app/nucleo_gestor_documental/', data, {
  //   headers: {'Content-Type': 'application/json'}
  // });
  // editDocument = (id, data) => AxiosClient.put(`/api/app/nucleo_gestor_documental/${id}/`, data, {
  //   headers: {'Content-Type': 'application/json'}
  // });
  getAreas = () => GestorDocumentalClient.post('/api/IGDAPI/Area',{
    email: config.gestorDocumental.email
  }, {
    headers: {'Content-Type': 'application/json'}
  });
  getCarpetas = idArea => GestorDocumentalClient.post('/api/IGDAPI/CarpetaEncabezado',{
    areaid: idArea
  }, {
    headers: {'Content-Type': 'application/json'}
  });
  getSubNiveles = filter => GestorDocumentalClient.post('/api/IGDAPI/CarpetaDetalle', filter, {
    headers: {'Content-Type': 'application/json'}
  });
  getSubNivelList = filter => GestorDocumentalClient.post('/api/IGDAPI/MantenimientoSubniveles', filter, {
    headers: {'Content-Type': 'application/json'}
  });
  viewDocument = filter => GestorDocumentalClient.post('/api/IGDAPI/ConsultaDocumento', filter, {
    headers: {'Content-Type': 'application/json'}
  });
}

export default new GestorDocumentalServices();